import { TFunction } from 'i18next'

interface WhatsAppErrorData {
  errorType?: string
  errorCode?: number
  userMessage?: string
  helpLink?: string
}

interface ToastData {
  message: string
  helpLink?: string
  showMetaBadge?: boolean
}

export function handleWhatsAppError(
  error: any,
  t: TFunction,
  defaultMessage: string
): ToastData {
  const errorData: WhatsAppErrorData | undefined = error?.response?.data

  if (!errorData?.errorType) {
    return {
      message: defaultMessage,
    }
  }

  const message =
    errorData.userMessage ||
    t(`whatsapp.errorTypes.${errorData.errorType}` as any, defaultMessage)

  return {
    message,
    helpLink: errorData.helpLink || undefined,
    showMetaBadge: errorData.errorType?.startsWith('META_') || false,
  }
}
